<template>
<div>
    <div class="loading_all_lot_list primary--text" v-if="loading_page === true">
        <v-progress-circular indeterminate size="80" color="primary"></v-progress-circular>
        <h2>Loading...</h2>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h3>ดูรายการ เข้า-ออก ทั้งหมด</h3>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>

            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.date}}</td>
                        <td>{{dataDetail.item.name}}</td>
                        <td>{{dataDetail.item.price}}</td>
                        <td>{{dataDetail.item.user_name}}</td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_all_lot_list" @click="lotDetail(dataDetail.item.id,dataDetail.item.type)">
                                        <v-list-item-title>ดูรายละเอียด</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_all_lot_list" @click="lotEdit(dataDetail.item.id,dataDetail.item.type)" v-if="$store.state.userProfile.permission_type == 1">
                                        <v-list-item-title>แก้ไข</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
            </v-data-table>

        </v-card>
    </div>
</div>
</template>

<script>
import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
export default {
    data() {
        return {
            loading_page: true,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'start',
                    value: 'date',
                },
                {
                    text: 'รายการ',
                    value: 'name'
                },
                {
                    text: 'มูลค่ารวม',
                    value: 'price'
                },
                {
                    text: 'ผู้บันทึก',
                    value: 'user_name'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async stockList() {
            this.loading_page = true
            inoutstockall.lotInOutList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.list
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async lotDetail(id, name) {
            const idPage = {
                id: id
            }
            if (name === 1) {
                this.$store.commit('lotDetailInPage', idPage)
                this.$router.push('/lotdetailin')
            }
            if (name === 0) {
                this.$store.commit('lotDetailOutPage', idPage)
                this.$router.push('/lotdetailout')
            }

        },
        async lotEdit(id, name) {
            const idPage = {
                id: id
            }
            if (name === 1) {
                this.$store.commit('lotDetailInEditPage', idPage)
                this.$router.push('/lotdetailinedit')
            }
            if (name === 0) {
                this.$store.commit('lotDetailOutEditPage', idPage)
                this.$router.push('/lotdetailoutedit')
            }

        }
    },
    mounted() {
        this.stockList()
    },
}
</script>

<style scoped>
.cursor_all_lot_list {
    cursor: pointer;
}

.loading_all_lot_list {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
}
</style>
